import { API_CREATE_FAVORITE, API_CREATE_FAVORITE_SUCCESS, API_DELETE_FAVORITE, API_DELETE_FAVORITE_MANY, API_DELETE_FAVORITE_MANY_SUCCESS, API_DELETE_FAVORITE_SUCCESS, } from '../actions/FavoriteActions';
import { API_GET_LIST_RECOMMENDATION_SOLUTION, API_GET_LIST_RECOMMENDATION_SOLUTION_SUCCESS, API_GET_ONE_SOLUTION, API_GET_ONE_SOLUTION_FAILURE, API_GET_ONE_SOLUTION_SUCCESS, } from '../actions/OneSolutionActions';
import { FORBIDDEN } from '../define/response';
import { updateFavoriteList } from '../helpers/favorite';
const updateState = (state, meta, values) => {
    const { id } = meta;
    const currentValue = state[id] || {};
    return Object.assign(Object.assign({}, state), { [id]: Object.assign(Object.assign({}, currentValue), values) });
};
const getOnes = (state) => {
    const items = [];
    Object.values(state).forEach((item) => {
        if (item.one) {
            items.push(item.one);
        }
        if (item.recommendation) {
            items.push(...item.recommendation);
        }
    });
    return items;
};
// eslint-disable-next-line default-param-last
export default (state = {}, { code, meta, payload, type }) => {
    switch (type) {
        // 取得開始
        case API_GET_ONE_SOLUTION: {
            const v = updateState(state, meta, {
                forbidden: false,
                one: null,
                recommendation: [],
            });
            return Object.assign({}, v);
        }
        // 取得成功
        case API_GET_ONE_SOLUTION_SUCCESS: {
            const v = updateState(state, meta, {
                one: Object.assign({}, payload),
            });
            return Object.assign({}, v);
        }
        // 取得失敗
        case API_GET_ONE_SOLUTION_FAILURE: {
            const v = updateState(state, meta, {
                forbidden: code === FORBIDDEN,
            });
            return Object.assign({}, v);
        }
        // おすすめ取得開始
        case API_GET_LIST_RECOMMENDATION_SOLUTION: {
            const v = updateState(state, meta, {
                recommendation: [],
            });
            return Object.assign({}, v);
        }
        // おすすめ取得成功
        case API_GET_LIST_RECOMMENDATION_SOLUTION_SUCCESS: {
            const v = updateState(state, meta, {
                recommendation: payload.list,
            });
            return Object.assign({}, v);
        }
        // お気に入り処理
        case API_CREATE_FAVORITE:
        case API_DELETE_FAVORITE:
        case API_CREATE_FAVORITE_SUCCESS:
        case API_DELETE_FAVORITE_SUCCESS:
        case API_DELETE_FAVORITE_MANY:
        case API_DELETE_FAVORITE_MANY_SUCCESS: {
            updateFavoriteList(getOnes(state), meta, payload, type);
            return Object.assign({}, state);
        }
        default: {
            return state;
        }
    }
};
